import clsx from 'clsx';
import { HoverCard as HoverCardPrimitive } from 'radix-ui';
import type { ComponentProps, ReactNode } from 'react';

interface RootProps extends ComponentProps<typeof HoverCardPrimitive.Root> {
  children?: ReactNode;
}
const HubertHoverCard = ({ children, ...props }: RootProps) => {
  return <HoverCardPrimitive.Root {...props}>{children}</HoverCardPrimitive.Root>;
};

interface TriggerProps extends ComponentProps<typeof HoverCardPrimitive.Trigger> {
  className?: string;
  children: ReactNode;
}
function Trigger({ className, children, ...props }: TriggerProps) {
  return (
    <HoverCardPrimitive.Trigger {...props} className={clsx(className)}>
      {children}
    </HoverCardPrimitive.Trigger>
  );
}

interface ContentProps extends ComponentProps<typeof HoverCardPrimitive.Content> {
  children: ReactNode;
  portalContent?: boolean;
  portalElement?: HTMLElement;
  className?: string;
}
function Content({ children, portalContent, portalElement, className = '', ...props }: ContentProps) {
  if (portalContent) {
    return (
      <HoverCardPrimitive.Portal container={portalElement}>
        <HoverCardPrimitive.Content
          {...props}
          className={clsx(
            'bg-white p-5',
            // 'bg-primary-50 p-5',
            'rounded-lg',
            'shadow-current',
            'shadow-[0_10px_38px_-10px_hsla(206,22%,7%,.35),0_10px_20px_-15px_hsla(206,22%,7%,.2)]',
            'will-change-[transform,opacity]',
            'z-10',
            'data-[state=open]:data-[side=top]:animate-slideDownAndFade',
            'data-[state=open]:data-[side=right]:animate-slideLeftAndFade',
            'data-[state=open]:data-[side=bottom]:animate-slideUpAndFade',
            'data-[state=open]:data-[side=left]:animate-slideRightAndFade',
            className,
          )}
          sideOffset={5}
        >
          {children}

          <HoverCardPrimitive.Arrow className="fill-white" />
        </HoverCardPrimitive.Content>
      </HoverCardPrimitive.Portal>
    );
  }

  return (
    <HoverCardPrimitive.Content
      {...props}
      className={clsx(
        'bg-white p-5',
        // 'bg-primary-50 p-5',
        'rounded-lg',
        'shadow-current',
        'shadow-[0_10px_38px_-10px_hsla(206,22%,7%,.35),0_10px_20px_-15px_hsla(206,22%,7%,.2)]',
        'will-change-[transform,opacity]',
        'z-10',
        'data-[state=open]:data-[side=top]:animate-slideDownAndFade',
        'data-[state=open]:data-[side=right]:animate-slideLeftAndFade',
        'data-[state=open]:data-[side=bottom]:animate-slideUpAndFade',
        'data-[state=open]:data-[side=left]:animate-slideRightAndFade',
        className,
      )}
      sideOffset={5}
    >
      {children}

      <HoverCardPrimitive.Arrow className="fill-white" />
    </HoverCardPrimitive.Content>
  );
}

HubertHoverCard.Trigger = Trigger;
HubertHoverCard.Content = Content;
export default HubertHoverCard;
